import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class MidlifeScene extends MinigameScene {
    //Images

    //values
    //private moveSpeed = 0;//100;
    private timeToReachMaxSpeed = 5000;
    private maxSpeed = 326.5;

    private objectConfig = [
        {image: CONST.MIDLIFE.BEER, x: 530, y: 140, required: false, scale: 1},
        {image: CONST.MIDLIFE.CAR, x: 869, y: 149, required: true, scale: 1.48},
        {image: CONST.MIDLIFE.CANDY, x: 1244, y: 115, required: false, scale: 1.5},
        {image: CONST.COFFEE.NORMAL_CHEESE, x: 1562, y: 120, required: false, scale: 1},
        {image: CONST.COFFEE.NORMAL_COFFEE, x: 1859, y: 100, required: false, scale: 1},
        {image: CONST.COFFEE.NORMAL_MILK, x: 2200, y: 100, required: false, scale: 1},
        {image: CONST.MIDLIFE.WEIGHTS, x: 2598, y: 106, required: true, scale: 1.65},
        {image: CONST.MIDLIFE.PANTIES, x: 3045, y: 106, required: false, scale: 1.65},
        {image: CONST.COFFEE.NORMAL_PEPPER, x: 3465, y: 122, required: false, scale: 1.65},
        {image: CONST.MIDLIFE.TICKET, x: 3927, y: 117, required: true, scale: 1.36},
    ];

    private cartPos = {x: 165, y: 310};
    private maxDistance = {x: 165, y: 50};

    //logic vars
    private timer = 0;
    private speed = 0;
    private jack !: object;
    private objects !: object[];

    private collisionShelf;
    private collisionOther;
    private collisionNone;

    constructor(){
        super ({
            sceneName: CONST.SCENES.MIDLIFE,
            duration: 15000,
            startScreenColor: 0xC1FFFF,
            startText: "MIDLIFE\nCRISIS!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            nextScene: CONST.SCENES.GRANDCHILDREN,
            endButtons: {
                normalNoSkip: {x: 430, y: 361, scale: 1.30},
                normalWithSkip: {x: 322, y: 361, scale: 1.0},
                skip: {x: 537, y: 361, scale: 1.0}
            }
          })
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.objects = [];
        this.timer = 0;
        this.speed = 0;
    }

    _preload(){
    }

    _create(){
        this.add.image(9779, 262, CONST.MIDLIFE.ENDLESSBACKGROUND).setDepth(9).setScale(45, 1);
        this.add.image(0, 0, CONST.MIDLIFE.BACKGROUND).setOrigin(0, 0).setDepth(10);

        this.add.image(745, 413, CONST.MIDLIFE.LIST).setDepth(11).setScrollFactor(0);
        this.spawnJack();

        this.initPhysics();
        this.spawnObjects();

    }

    private initPhysics(){
        this.matter.world.setBounds(0, 0, 10000, this.game.renderer.height);

        this.collisionShelf = this.matter.world.nextCategory();
        this.collisionOther = this.matter.world.nextCategory();
        this.collisionNone = this.matter.world.nextCategory();

        this.matter.add.rectangle(5000, 222, 9300, 15, {
            isStatic: true,
            collisionFilter: { category: this.collisionShelf }
        });
    }

    private spawnObjects(){
        var canDrag = this.matter.world.nextGroup(false);
        this.matter.add.mouseSpring({ length: 0,
                                     stiffness: 1,
                                     angularStiffness: 0,
                                     collisionFilter: { group: canDrag } });

        this.objectConfig.forEach(config => {
            var obj = this.matter.add.image(config.x, config.y,
                                                config.image,
                                                null,
                                                {})
                                    .setDepth(17)
                                    .setScale(config.scale, config.scale)
                                    .setInteractive({ useHandCursor: true })
                                    .setCollisionGroup(canDrag);
            obj.inCart = false;
            obj.relativeJackPos;
            obj.required = config.required;
            obj.config = config;
            obj.setCollisionCategory(this.collisionOther);
            obj.setCollidesWith([this.collisionOther, this.collisionShelf, 0x0001]);

            obj.putInCart = () => {
                obj.inCart = true;
                obj.setCollisionGroup(this.collisionNone);
                obj.setCollidesWith([]);
                obj.setStatic(true);
                obj.relativeJackPos = {x: obj.x - this.jack.x, y: obj.y - this.jack.y};

            }

            obj.update = () => {
                if (obj.inCart){
                    obj.setPosition(this.jack.x + obj.relativeJackPos.x, this.jack.y + obj.relativeJackPos.y);
                }
            }

            this.objects.push(obj)
        });

        this.matter.world.on ('dragstart', function(body, part) {
            //Copy of setCollidesWith because WTF IS WRONG WITH YOU PHASER
            var flags = 0;
            var categories = [this.collisionOther, 0x0001];
                for (var i = 0; i < categories.length; i++){
                    flags |= categories[i];
                }
    
            body.collisionFilter.mask = flags;
        }, this);


        this.matter.world.on ('dragend', function(body, part) {
            this.objects.forEach(obj => {
                if (obj.body === body){
                    if (Math.abs(obj.x - this.jack.x - this.cartPos.x) < this.maxDistance.x
                     && Math.abs(obj.y - this.cartPos.y) < this.maxDistance.y){
                         obj.putInCart();
                    }
                }
            });
        }, this);
    }

    private spawnJack(){
        var jack = this.add.image(333, 333, CONST.MIDLIFE.BODY).setDepth(20);

        var rightLeg = this.addAnimation(CONST.MIDLIFE.FEET, CONST.ANIMATIONS.MIDLIFERIGHTFOOT, 60)
                            .setLoop(true)
                            .setDepth(18)
                            .setScaleMultiplier(2.7, 9.6)
                            .setOffset(12, 0)
                            .setScrollFactor(0, 0)
                            .start();
        
        var leftLeg = this.addAnimation(CONST.MIDLIFE.FEET, CONST.ANIMATIONS.MIDLIFELEFTFOOT, 60)
                                .setLoop(true)
                                .setDepth(18)
                                .setScaleMultiplier(2.26, 9.5)
                                .setOffset(12, 0)
                                .setScrollFactor(0, 0)
                                .start();
        
        this.add.image(156, 161, CONST.MIDLIFE.HEAD).setDepth(22).setScrollFactor(0, 0);


        jack.update = (delta: number, jack: object) => {
            if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
            jack.x += this.speed * delta / 1000;
        }

        this.cameras.main.startFollow(jack, false, 1, 0, 
            jack.x - this.cameras.main.x - this.game.renderer.width / 2,  
            jack.y - this.cameras.main.y - this.game.renderer.height / 2);

        this.jack = jack;
    }

    _update(time: number, delta: number){
        this.calculateSpeed(delta);
        this.jack.update(delta, this.jack);

        this.objects.forEach(obj => obj.update());
    }

    private calculateSpeed(delta: number){
        if (this.isCurrentState(CONST.GAMESTATE.START)) return;
        this.timer += delta / this.timeToReachMaxSpeed;
        this.speed = Phaser.Math.Interpolation.SmoothStep (this.timer, 0, this.maxSpeed);
    }

    _timeout(){
        this.checkForWin();
    }

    private checkForWin(){
        var allInCart = true;
        var validCart = true;
        var emptyCart = true;

        for (let obj of this.objects){
            if (obj.inCart){
                emptyCart = false;
                if (!obj.required){
                    validCart = false;
                }
            } else {
                if (obj.required) {
                    validCart = false;
                }
                allInCart = false;
            }
        }

        if (validCart && !emptyCart){
            this.triggerWin();
        } else {
            this.triggerLoss(allInCart);
        }
    }

    _afterLoss(){
    }

    _afterWin(){
    }

    private triggerLoss(allInCart: boolean){
        this.add.image(this.jack.x - 333, 0, 
                allInCart ? CONST.MIDLIFE.ENDEVERYTHING : CONST.MIDLIFE.END)
                .setOrigin(0,0)
                .setDepth(999);
        this.loseGame();
    }

    private triggerWin(){
        this.addAnimation(CONST.MIDLIFE.WINIMAGE, CONST.ANIMATIONS.MIDLIFEWIN, 60)
        .setOffset(this.jack.x - 333, 0)
        .setLoop(false)
        .setDepth(999)
        .start();

        this.winGame(1500);
    }
}
